import { useCallback, useMemo } from 'react';
import { NewCustomerBanner } from './NewCustomerBanner';
import { OrderSource } from 'src/entities/Order';

function formatColor(status) {
  const colorStringed = status.toString();

  const color = {
    'Em validação': 'wait-card',
    Confirmada: 'confirmado-card',
    Confirmado: 'confirmado-card',
    'A confirmar': 'wait-card',
    Rejeitada: 'reject-card',
    Cancelado: 'reject-card',
    'Solicitar Revisão': 'reject-card',
    'Revisão Solicitada': 'reject-card',
  };

  return color[colorStringed] || 'null-card';
}

const Header = ({
  number,
  orderStatus,
  customer,
  registrationNumber,
  source,
  isNewCustomer,
  resgistrationType,
  stateRegistrationNumber,
  email,
  phone,
}) => {
  const transformOrderStatus = useCallback(status => {
    const statusObject = {
      WAITING_SALES_ORDER_VALIDATION: 'Em validação',
      TO_BE_CONFIRMED: 'A confirmar',
      CONFIRMED: 'Confirmada',
      INVOICE_RECEIVED: 'Confirmada',
      SHIPPED: 'Enviada',
      SHIPPING_CONFIRMED: 'Enviada',
      UNDER_REVIEW: 'Revisão Solicitada',
      CANCELLED: 'Cancelado',
      DELIVERED: 'Entregue',
    };

    return statusObject[status] || status;
  }, []);

  const orderStatusLabel = useMemo(() => {
    if (!orderStatus) return ' - ';

    return transformOrderStatus(orderStatus);
  }, [orderStatus]);

  const showCustomerBanner =
    source === OrderSource.MARKETPLACE && isNewCustomer;

  return (
    <>
      <div className="row my-2">
        <div className="col-12">
          <h1 className="title-section mt-0  fw-light">Pedido #{number}</h1>
        </div>
      </div>
      <div className="row my-2">
        <div className="col-12 d-flex align-items-center">
          <p className="float-left fw-bold text-muted text-uppercase">
            STATUS:
          </p>
          <p
            style={{
              marginLeft: '50px',
              width: 'fit-content',
              paddingLeft: 10,
              paddingRight: 10,
            }}
            className={
              orderStatusLabel ? formatColor(orderStatusLabel) : 'null-card'
            }
          >
            {orderStatusLabel}
          </p>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-12">
          <h2 style={{ fontSize: '1.5rem' }}>{customer || ''}</h2>
        </div>
      </div>

      {showCustomerBanner && <NewCustomerBanner />}

      <div className="row d-flex align-items-center">
        <div className="col-12 col-lg-6 col-xl-3">
          <p style={{ fontSize: '1rem' }}>
            <b>{resgistrationType}:</b> {registrationNumber || ' - '}
          </p>
        </div>
        <div className="col-12 col-lg-6 col-xl-3">
          <p style={{ fontSize: '1rem' }}>
            <b>I.E.:</b> {stateRegistrationNumber || ' - '}
          </p>
        </div>

        <div className="col-12 col-lg-6 col-xl-3">
          <p style={{ fontSize: '1rem' }}>
            <b>E-mail:</b> {email || ' - '}
          </p>
        </div>
        <div className="col-12 col-lg-6 col-xl-3">
          <p style={{ fontSize: '1rem' }}>
            <b>Telefone:</b> {phone || ' - '}
          </p>
        </div>
      </div>
    </>
  );
};

export default Header;
